import styled from 'styled-components';

import { QueryResult } from '../../../GlobalComponents/QueryResult';
import { useWebOnlineProductGroupsQuery } from '../../graphql';
import { useMenuNavigation } from '../../hooks/useMenuNavigation';
import { CategoryCard } from './components/CategoryCard';
import { Hero } from './components/Hero';
import BannerImage from '../../../assets/imgs/banner/main.jpg';

export const Root: React.FC = () => {
	const { data, loading, error } = useWebOnlineProductGroupsQuery({
		variables: { parentId: 0 }
	});

	const { selectProductGroup } = useMenuNavigation();
	return (
		<>
			<QueryResult data={data} loading={loading} error={error}>
				<Hero
					img={BannerImage}
					link={'/'}
					text={'Download the new app today!'}
				/>
				<Header>Order Now</Header>
				{data?.webOnlineProductGroups ? (
					<CategoryCard
						category={data?.webOnlineProductGroups}
						selectCategory={selectProductGroup}
						large
					/>
				) : null}
			</QueryResult>
		</>
	);
};

const Header = styled.div`
	color: #574d45;
	font-weight: 500;
	font-size: 36px;
	text-align: center;
	padding: 32px;

	@media (max-width: 600px) {
		font-size: 32px;
		padding: 16px;
	}
`;
